<!--
 * @Author: 张天昊
 * @Date: 2024-05-24 14:55:37
 * @LastEditTime: 2024-06-04 14:29:38
 * @LastEditors: 张天昊
 * @Description: 文件单元格
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/FileCell.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import { FileTypes } from '@/components/FilePreviewer';
import icDoc from '@/assets/itineraryUniversal/ic-doc.png';
import icPdf from '@/assets/itineraryUniversal/ic-pdf.png';
import icExcel from '@/assets/itineraryUniversal/ic-excel.png';
import icTxt from '@/assets/itineraryUniversal/ic-txt.png';
import icZip from '@/assets/itineraryUniversal/ic-zip.png';
import icVideo from '@/assets/itineraryUniversal/ic-video.png';
import icOther from '@/assets/itineraryUniversal/ic-otherfile.png';

const filetype2Icon = {
  [FileTypes.文稿]: icDoc,
  [FileTypes.文档]: icPdf,
  [FileTypes.表格]: icExcel,
  [FileTypes.文本]: icTxt,
  [FileTypes.压缩包]: icZip,
  [FileTypes.音视频]: icVideo
};

function getFileExtByName(name) {
  return name.split('.').pop().toLowerCase();
}

function getFileNameByUrl(url) {
  return url.split('/').pop();
}

export default defineComponent({
  props: {
    url: {
      type: String
    },
    size: {
      type: [Number, String]
    }
  },
  setup(props, { emit }) {
    const name = computed(() => getFileNameByUrl(props.url));
    const icon = computed(() => {
      const ext = getFileExtByName(name.value);
      if (ext) {
        if (FileTypes.图片.split(',').includes(ext)) {
          return props.url
        }
        for (let key of Object.keys(filetype2Icon)) {
          if (key.includes(ext)) {
            return filetype2Icon[key];
          }
        }
      }
      return icOther;
    });

    function onClick() {
      emit('click', { fileType: getFileExtByName(name.value), url: props.url });
    }
    return {
      name,
      icon,
      onClick
    };
  }
});
</script>

<template>
  <div class="flex overflow-hidden items-center" @click="onClick">
    <div class="w-34 h-38 flex-shrink-0">
      <img :src="icon" class="w-full h-full fit-cover" />
    </div>
    <!-- <div class="ml-8 flex-auto text-14 leading-20 overflow-hidden">
      <div class="truncate">{{ name }}</div>
      <div class="text-14 leading-20 text-grey-g">{{ size }}</div>
    </div> -->
    <div class="truncate ml-8 flex-auto text-16 leading-20">{{ name }}</div>
  </div>
</template>
